import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { toast } from 'react-toastify'

import { getURLToDownloadFile } from '@/services/get-url-to-download-file'

const GET_COG_URL_FROM_DIAGNOSIS_KEY = 'get-cog-url-from-diagnosis'

export function useGetCogUrlFromDiagnosis(culture: string, demandId?: string) {
  return useQuery({
    queryKey: [GET_COG_URL_FROM_DIAGNOSIS_KEY, culture, demandId],
    queryFn: () => getURLToDownloadFile(culture, demandId!, 'mosaic_cog'),
    onError(e: Error) {
      if (axios.isAxiosError(e) && e.response?.status === 404) {
        return toast.info(
          'Este diagnóstico não possui um mosaico disponível para visualização.',
        )
      }

      toast.error('Ocorreu um erro visualizar o mosaico: ' + e.message)
    },
    enabled: !!demandId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
